var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatureTaskManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 40 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M38.8281 25.2794H35.334V21.6577C35.334 21.0105 34.8093 20.4859 34.1621 20.4859H21.1719V18.1914C25.6566 17.6145 29.1332 13.7723 29.1332 9.1332C29.1332 4.09711 25.0361 0 20 0C14.964 0 10.8669 4.09711 10.8669 9.1332C10.8669 13.7722 14.3435 17.6145 18.8281 18.1914V20.4859H5.83789C5.1907 20.4859 4.66602 21.0105 4.66602 21.6577V25.2793H1.17188C0.524687 25.2793 0 25.804 0 26.4512V33.3778C0 34.025 0.524687 34.5497 1.17188 34.5497H10.5039C11.1511 34.5497 11.6758 34.025 11.6758 33.3778V26.4512C11.6758 25.804 11.1511 25.2793 10.5039 25.2793H7.00977V22.8296H18.8281V25.2793H15.334C14.6868 25.2793 14.1621 25.804 14.1621 26.4512V33.3778C14.1621 34.025 14.6868 34.5497 15.334 34.5497H24.666C25.3132 34.5497 25.8379 34.025 25.8379 33.3778V26.4512C25.8379 25.804 25.3132 25.2793 24.666 25.2793H21.1719V22.8296H32.9902V25.2793H29.496C28.8488 25.2793 28.3241 25.804 28.3241 26.4512V33.3778C28.3241 34.025 28.8488 34.5497 29.496 34.5497H38.8281C39.4753 34.5497 40 34.025 40 33.3778V26.4512C40 25.8041 39.4753 25.2794 38.8281 25.2794ZM9.33203 27.6231V32.206H2.34375V27.6231H9.33203ZM23.4941 27.6231V32.206H16.5059V27.6231H23.4941ZM20 15.9227C16.2563 15.9227 13.2106 12.877 13.2106 9.13328C13.2106 5.38953 16.2563 2.34383 20 2.34383C23.7437 2.34383 26.7895 5.38953 26.7895 9.13328C26.7895 12.877 23.7437 15.9227 20 15.9227ZM37.6562 32.206H30.668V27.6231H37.6562V32.206Z",
    fill: "var(--fill-0, #4B4B4B)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.3252 7.96141H21.1719V5.81859C21.1719 5.17141 20.6472 4.64672 20 4.64672C19.3528 4.64672 18.8281 5.17141 18.8281 5.81859V9.13328C18.8281 9.78047 19.3528 10.3052 20 10.3052H22.3252C22.9724 10.3052 23.4971 9.78047 23.4971 9.13328C23.4971 8.48609 22.9723 7.96141 22.3252 7.96141Z",
    fill: "var(--fill-0, #4B4B4B)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureTaskManager);
export default __webpack_public_path__ + "static/media/feature-task-manager.2449ca0b052bd2f2430b61197738fbdb.svg";
export { ForwardRef as ReactComponent };